import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import { PersistGate } from 'redux-persist/es/integration/react';
import App from './app';
import history from './app/history';
import setupStore from './app/setup-store';
import ReduxToastr from 'react-redux-toastr';
import '../styles/index.scss';

setupStore().then(({ store, persistor }) => {
  let app = (
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <Router history={history}>
          <App />
        </Router>
        <ReduxToastr />
      </PersistGate>
    </Provider>
  );
  let node = document.getElementById('app');
  node.classList.add('app', `app--${process.env.APP_ENV}`);
  ReactDOM.render(app, node);
});
